import { generateMaterialIcon, generateFontAwesomeIcon, IconWithText } from './Icons';



export default {
  VisibilityOn: generateMaterialIcon('visibility', '16px', '16px', '16px'),
  VisibilityOff: generateMaterialIcon('visibility_off', '16px', '16px', '16px'),
  X: generateMaterialIcon('clear', '20px', '30px', '30px'),


  // these icons have been set to specific size, changing them will mess things up. bad idea? maybe.
  // ArrowLeft: generateMaterialIcon('arrow_back', '20px', '30px', '30px'),
  // ArrowRight: generateMaterialIcon('arrow_forward', '20px', '37px', '37px'),
  // Language: generateMaterialIcon('language', '20px', '20px', '20px'),
  // AttachmentSmall: generateMaterialIcon('attach_file', '12px', '16px', '16px'),

  // FileAll: generateFontAwesomeIcon('files-o', '30px', '30px', '30px'),
  // FileDocument: generateFontAwesomeIcon('file-text-o', '30px', '30px', '30px'),
  // FilePhoto: generateFontAwesomeIcon('file-photo-o', '30px', '30px', '30px'),
  // FileVideo: generateFontAwesomeIcon('file-video-o', '30px', '30px', '30px'),
  // FileOther: generateFontAwesomeIcon('file-o', '30px', '30px', '30px'),
  // FilePlaceholder: generateFontAwesomeIcon('file-o', '30px', '30px', '30px'),

  // Attachment: generateMaterialIcon('attach_file', '20px', '20px', '30px'),
  // Write: generateFontAwesomeIcon('pencil', '20px', '20px', '20px'),
  // Calendar: generateMaterialIcon('event', '20px', '20px', '30px'),
  // Anatomy: generateMaterialIcon('accessibility', '20px', '20px', '30px'),
  // StoppingReason: generateFontAwesomeIcon('minus-circle', '20px', '20px', '30px'),

  // Add: generateMaterialIcon('add', '30px', '40px', '40px'),
  // FlagCircle: generateFontAwesomeIcon('circle-thin', '18px', '24px', '24px'),
  // FlaggedCircle: generateFontAwesomeIcon('circle', '18px', '24px', '24px'),


  // FileOtherLarge: generateFontAwesomeIcon('file-o', '100px', '100px', '100px'),

  // Trashcan: generateMaterialIcon('delete', '40px', '56px', '56px'),
  // Timer: generateMaterialIcon('access_time', '20px', '20px', '30px'),
  // Frown: generateMaterialIcon('sentiment_dissatisfied', '20px', '30px', '30px'),

  // Email: generateFontAwesomeIcon('envelope', '20px', '20px', '24px'),
  // Lock: generateFontAwesomeIcon('lock', '20px', '20px', '24px'),
  // Shield: generateFontAwesomeIcon('shield', '20px', '20px', '24px'),

  // // icons below might be okay to change (move above this line after changing them)
  // Search: generateFontAwesomeIcon('search', '28px', '56px', '56px'),
  // Messages: generateFontAwesomeIcon('comment', '28px', '56px', '56px'),
  // Share: generateFontAwesomeIcon('share', '28px', '56px', '56px'),
  // Close: generateFontAwesomeIcon('times-circle', '40px', '56px', '56px'),
  // BackArrow: generateFontAwesomeIcon('arrow-circle-o-left', '40px', '56px', '56px'),
  // Notes: generateFontAwesomeIcon('pencil', '20px', '30px', '30px'),
  // Files: generateFontAwesomeIcon('file-o', '20px', '30px', '30px'),
  // Ellipsis: generateFontAwesomeIcon('ellipsis-h', '40px', '56px', '56px'),
  // Download: generateFontAwesomeIcon('download', '20px', '56px', '56px'),
  // ShareAlt: generateFontAwesomeIcon('share-alt', '20px', '56px', '56px'),
  // CreditCard: generateFontAwesomeIcon('credit-card', '16px', '16px', '16px'),
  // // Warning: generateFontAwesomeIcon('exclamation-circle', '156px', '156px',156px'),

  // ClearField: generateMaterialIcon('backspace', '20px', '40px', '40px'),

  // LargeX: generateMaterialIcon('clear', '40px', '56px', '56px'),

  // ArrowDropDown: generateMaterialIcon('arrow_drop_down', '20px', '20px', '20px'),

  IconWithText,

};
